import styled from 'styled-components'

export const Label = styled.label`
    padding-right: 1%;
    margin: 0;
`
